import React, { useMemo } from "react"

import { useComponentizedPage } from "store/contexts/componentized-page"

import ImageGallery from "components/image-gallery"
import ContentfulImage from "./image"

const ContentfulProductGallery = ({ onTop }) => {
  const { shopifyProductVariant: pageShopifyProductVariant } = useComponentizedPage()

  const items = useMemo(() => {
    const shopifyProduct = pageShopifyProductVariant?.product
    if (shopifyProduct) {
      return shopifyProduct.media.map((item) => ({
        image: [{ secure_url: `${item.image.originalSrc}` }],
      }))
    }

    return []
  }, [pageShopifyProductVariant])

  if (items?.length === 0) {
    return
  }

  return (
    <ImageGallery
      images={items.map((item) => (
        <ContentfulImage
          key={item.image[0].secure_url}
          component={{
            ...item,
            image: [{ ...item.image[0], width: 1440, height: 1440 }],
            useOriginalAspectRatio: true,
          }}
          onTop={onTop}
          nested
          crop
        />
      ))}
    />
  )
}

export default ContentfulProductGallery
